import API from "../index";
import {TCountryResponse, TRequestCountryCallback} from "./interfaces/country";

export const getCountries: TRequestCountryCallback = () => {
    return API.get<TCountryResponse>(`/country`)
        .then(({data}) => data)
}